<app-modal [modalConfig]="modalConfig">
    <ng-container *ngIf="report.parametros && report.parametros.length > 0">
        <form [formGroup]="reportForm" autocomplete="off">
            <div class="form-container" formArrayName="parameters">
                <ng-container *ngFor="let parameter of parameters.controls, let i=index">
                    <ng-container *ngIf="!validateSystemUser(parameter.get('name')?.value)">
                        <app-type-input *ngIf="!parameter.get('isMultiple')?.value" [formGroupName]="i"
                            [input]="getCustomInput(i)" [control]="getParameterValue(parameter)" ngDefaultControl />
                        <app-multiple-input *ngIf="parameter.get('isMultiple')?.value" [formGroupName]="i"
                            [input]="getCustomInput(i)" [formArray]="getParametersValues(parameter)" ngDefaultControl />
                    </ng-container>
                </ng-container>
            </div>
        </form>
    </ng-container>
    <button class="btn-submit" type="button" [disabled]="isLoading" (click)="onSubmit()">Generar</button>
    <ngx-loading [show]="isLoading">
    </ngx-loading>
</app-modal>